import _ from "lodash";
import env from "../constants/env";

// Each region serves its assets bucket from its own hosts: private-assets(-eu|-eu2).ambifi.com and
// public-assets(-eu|-eu2).ambifi.com serve the bucket's private/ and public/ folders (dev-private-assets… on dev), and
// assets(…).ambifi.com the whole bucket. Checks for the US hosts alone turned London files into keys that don't exist.
const PRIVATE_ASSET_HOST = /(^|[.-])private-assets(-[a-z0-9]+)?\.ambifi\.com$/;
const PUBLIC_ASSET_HOST = /(^|[.-])public-assets(-[a-z0-9]+)?\.ambifi\.com$/;

function hostnameOf(url) {
	try {
		return new URL(url).hostname.toLowerCase();
	} catch (_err) {
		return "";
	}
}

/**
 * The assets bucket folder an asset host serves: "private", "public", or null for any other host.
 */
export function getAssetHostFolder(hostname) {
	const host = _.toString(hostname).toLowerCase();
	if (host === "") {
		return null;
	}
	if (host === hostnameOf(_.get(env, ["cloudFront", "assetUrls", "private"])) || PRIVATE_ASSET_HOST.test(host)) {
		return "private";
	}
	if (host === hostnameOf(_.get(env, ["cloudFront", "assetUrls", "public"])) || PUBLIC_ASSET_HOST.test(host)) {
		return "public";
	}
	return null;
}

function decodeUrlPathPart(part = "") {
	let decoded = _.toString(part);
	for (let index = 0; index < 4; index += 1) {
		try {
			const next = decodeURIComponent(decoded);
			if (next === decoded) {
				break;
			}
			decoded = next;
		} catch (_err) {
			break;
		}
	}
	return decoded;
}

/**
 * The assets bucket key behind an asset URL: the private and public hosts' folder plus the decoded path, without the
 * query string. Any other host's path is the key as it is (the plain assets host serves the whole bucket). "" when the
 * value is not a URL.
 */
export function getAssetsKeyFromUrl(assetUrl) {
	if (!_.isString(assetUrl) || assetUrl === "" || assetUrl === "none") {
		return "";
	}
	try {
		const parsedUrl = new URL(assetUrl);
		const path = parsedUrl.pathname.replace(/^\/+/, "").split("/").map(decodeUrlPathPart).join("/");
		if (path === "") {
			return "";
		}
		const folder = getAssetHostFolder(parsedUrl.hostname);
		return folder ? `${folder}/${path}` : path;
	} catch (_err) {
		return "";
	}
}
